export const AVATAR_BUCKET = 'avatars';
const MAX_SIDE = 512;

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('unreadable image')); };
  img.src = url;
});

// Center-crop to a square and shrink so uploads stay small whatever the
// phone produced. Returns a JPEG blob.
export const prepareAvatar = async (file) => {
  if (!file || !file.type.startsWith('image/')) throw new Error('not an image');
  const img = await loadImage(file);
  const side = Math.min(img.naturalWidth, img.naturalHeight);
  const size = Math.min(MAX_SIDE, side);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);
  ctx.drawImage(img, (img.naturalWidth - side) / 2, (img.naturalHeight - side) / 2, side, side, 0, 0, size, size);
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('encode failed'))), 'image/jpeg', 0.86);
  });
};

// Uploads to a fixed path per subject (overwriting the previous photo) and
// returns a public URL with a cache-busting query so the new image shows at once.
export const uploadAvatar = async (supabase, path, file) => {
  const blob = await prepareAvatar(file);
  const { error } = await supabase.storage
    .from(AVATAR_BUCKET)
    .upload(path, blob, { upsert: true, contentType: 'image/jpeg', cacheControl: '3600' });
  if (error) throw error;
  const { data } = supabase.storage.from(AVATAR_BUCKET).getPublicUrl(path);
  return `${data.publicUrl}?v=${Date.now()}`;
};

export const removeAvatar = async (supabase, path) => {
  const { error } = await supabase.storage.from(AVATAR_BUCKET).remove([path]);
  if (error) throw error;
};

export const memberAvatarPath = (projetoId, membroId) => `membros/${projetoId}/${membroId}.jpg`;
export const profileAvatarPath = (userId) => `perfis/${userId}/avatar.jpg`;
